import React from "react";
import { Modal as AntModal } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { getFormattedNumber } from "@utils";
import {
  BonusModalCH,
  BonusModalEN,
  BonusModalMM,
  PromoBonusModalCH,
  PromoBonusModalMM,
  PromoBonusModalEN,
  FirstTopUpAccept,
  FirstTopUpReject,
} from "@assets";
import { localStorage } from "@utils";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";

const Modal = styled(AntModal)`
  padding: 0px !important;
  .ant-modal-title {
    text-align: center;
    color: ${(props) => props.theme.primaryColor};
  }
  .ant-modal-content {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }

  .ant-modal-footer {
    text-align: center;
  }
`;

const Container = styled.div`
  position: absolute;
  top: 90px;
  left: 0;
  margin: 18px 0;
  height: 322px;
  width: 100%;

  @media screen and (max-width: 370px) {
    height: 272px;
    top: 80px;
  }
`;

const LabelContainer = styled.div`
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const FirstLabel = styled.div`
  font-weight: 400;
  color: #fff;
  width: 100%;
  font-size: 13px;
  text-align: center;
  line-height: 2;
  span {
    font-weight: bold;
  }
  @media screen and (max-width: 370px) {
    font-size: 10px;
  }
`;

const TopUpLabel = styled.div`
  font-weight: 400;
  color: #fff;
  width: 100%;
  font-size: 13px;
  text-align: center;
  line-height: 2;
  span {
    font-weight: bold;
  }
  @media screen and (max-width: 370px) {
    font-size: 10px;
  }
`;

const TotalLabel = styled.div`
  font-weight: 400;
  color: #fff;
  width: 100%;
  font-size: 13px;
  text-align: center;
  line-height: 2;
  span {
    font-weight: bold;
  }
  @media screen and (max-width: 370px) {
    font-size: 10px;
  }
`;

const RuleLabel = styled.div`
  padding-bottom: 0;
  font-size: 10px;
  color: #ffce00;

  @media screen and (max-width: 370px) {
    font-size: 9px;
    padding-bottom: 0;
  }
`;

const BtnWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  @media screen and (max-width: 370px) {
    gap: 3px;
  }
`;

const CancelButton = styled.button`
  padding-top: ${() =>
    localStorage.getUserPreferedLanguage() === BURMESE_LANGUAGE_CODE_LK
      ? "17px"
      : "22px"};
  background-image: url(${FirstTopUpReject});
  background-size: cover;
  background-repeat: no-repeat;
  background-color: transparent;
  width: 152px;
  height: 68px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 50px;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  @media screen and (max-width: 370px) {
    width: 110px;
    height: 50px;
    font-size: 12px;
    padding-top: ${() =>
    localStorage.getUserPreferedLanguage() === BURMESE_LANGUAGE_CODE_LK
      ? "10px"
      : "15px"};
  }
`;

const AcceptButton = styled.button`
  padding-top: ${() =>
    localStorage.getUserPreferedLanguage() === BURMESE_LANGUAGE_CODE_LK
      ? "17px"
      : "22px"};
  background-image: url(${FirstTopUpAccept});
  background-size: cover;
  background-repeat: no-repeat;
  background-color: transparent;
  width: 152px;
  height: 68px;
  color: #000000;
  font-size: 14px;
  text-align: center;
  border: none;
  cursor: pointer;
  position: relative;
  border-radius: 50px;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  @media screen and (max-width: 370px) {
    width: 110px;
    height: 50px;
    font-size: 12px;
    padding-top: ${() =>
    localStorage.getUserPreferedLanguage() === BURMESE_LANGUAGE_CODE_LK
      ? "10px"
      : "15px"};
  }
`;

const LottieWrapper = styled.div`
  width: 350px;
  position: relative;

  @media screen and (max-width: 370px) {
    width: 300px;
  }
`;

const Bottom = styled.div`
  position: absolute;
  bottom: 110px;
  width: 100%;
  text-align: center;

  @media screen and (max-width: 370px) {
    bottom: 100px;
  }
`;

export const Image = styled.img.attrs({
  alt: "logo",
})`
  object-fit: contain;
  width: 350px;

  @media screen and (max-width: 370px) {
    width: 300px;
  }
`;

const FirstBonusConfirmModal = ({
  exceed_bonus_limit,
  total_amount,
  max_topup_reward,
  amount,
  bonus_percent,
  isPromoUser,
  open,
  onBonusAccept,
  handleClose,
}) => {
  const { t } = useTranslation();

  const calculateBonus = () => {
    return exceed_bonus_limit ? max_topup_reward : Math.ceil(amount * bonus_percent * 0.01);
  }

  const calculateTotal = () => {
    return exceed_bonus_limit ? total_amount : (amount + calculateBonus());
  }

  const getBonusModal = () => {
    const userPreferedLanguage = localStorage.getUserPreferedLanguage();

    if (isPromoUser) {
      if (userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK) {
        return PromoBonusModalEN;
      } else if (userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK) {
        return PromoBonusModalMM;
      } else {
        return PromoBonusModalCH;
      }
    } else {
      if (userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK) {
        return BonusModalEN;
      } else if (userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK) {
        return BonusModalMM;
      } else {
        return BonusModalCH;
      }
    }
  };

  return (
    <>
      <Modal centered destroyOnClose closable={false} open={open} footer={null}>
        <LottieWrapper>
          <Image src={getBonusModal()} />
          <Container>
            <LabelContainer>
              <FirstLabel>
                {t("wallet.firstTopUpBonusPercentage1")}
                {" - "}
                <span>{bonus_percent}%</span>{" "}
                {t("wallet.firstTopUpBonusPercentage2")}
              </FirstLabel>
              <TopUpLabel>
                {t("wallet.firstTopUpBonusTopUpAndBonus1")}
                {" - "}
                <span>{getFormattedNumber(amount)}</span>
                {"၊ "}
                {t("wallet.firstTopUpBonusTopUpAndBonus2")}
                {" - "}
                <span>{getFormattedNumber(calculateBonus())}</span>
              </TopUpLabel>
              <TotalLabel>
                {t("wallet.firstTopUpBonusTotal1")}{" "}
                <span>{getFormattedNumber(calculateTotal())}</span>{" "}
                {t("wallet.firstTopUpBonusTotal2")}
              </TotalLabel>
              {exceed_bonus_limit &&
                <TotalLabel>
                  {t("wallet.maxBonusAmount", { max_topup_reward: getFormattedNumber(max_topup_reward) })}
                </TotalLabel>
              }
            </LabelContainer>
            <Bottom>
              <RuleLabel>{t("wallet.firstTopUpBonusRule")}</RuleLabel>
              <BtnWrapper>
                <CancelButton onClick={handleClose}>
                  {t("wallet.reject")}
                </CancelButton>
                <AcceptButton onClick={onBonusAccept}>
                  {t("wallet.accept")}
                </AcceptButton>
              </BtnWrapper>
            </Bottom>
          </Container>
        </LottieWrapper>
      </Modal>
    </>
  );
};

export default FirstBonusConfirmModal;
